import { Link } from 'react-router-dom';
import type { WorkspaceSummary } from '../api';
import { can, useMe } from '../useData';

// Pagina de start după autentificare. Widget-urile se vor configura ulterior.
export function DashboardPage({ workspaces }: { workspaces: WorkspaceSummary[] }) {
  const me = useMe();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Bună dimineața' : hour < 18 ? 'Bună ziua' : 'Bună seara';

  return (
    <>
      <div className="page-head">
        <h1>{greeting}, {me.displayName.split(' ')[0]}</h1>
      </div>

      <section>
        <h2>Workspace-urile mele</h2>
        <div className="cards">
          {workspaces.map((w) => (
            <Link key={w.id} to={`/w/${w.id}`} className="card">
              <div className="card-bar" style={{ background: w.color ?? '#083050' }} />
              <h3>{w.name}</h3>
              <div className="card-meta">
                <span>{w.appCount} aplicații</span>
                <span>{w.memberCount} membri</span>
              </div>
            </Link>
          ))}
          {workspaces.length === 0 && <p className="muted">Nu sunteți încă membru în niciun workspace.</p>}
        </div>
      </section>

      <section>
        <h2>Dashboard</h2>
        <div className="cards">
          <div className="card widget-placeholder">
            <h3>Sarcinile mele</h3>
            <p className="muted">Sarcinile atribuite vouă vor apărea aici.</p>
          </div>
          <div className="card widget-placeholder">
            <h3>Mesaje noi</h3>
            <p className="muted">E-mail și WhatsApp — după integrarea canalelor de comunicare.</p>
          </div>
          <div className="card widget-placeholder">
            <h3>Activitate recentă</h3>
            <p className="muted">Ultimele modificări din workspace-urile voastre.</p>
          </div>
          {can(me, 'admin.resources.view') && (
            <Link to="/admin/resources" className="card widget-placeholder">
              <h3>Resurse și costuri</h3>
              <p className="muted">Starea serverelor și costul lunii curente →</p>
            </Link>
          )}
        </div>
        <p className="muted small">Conținutul acestui dashboard îl vom configura împreună ulterior.</p>
      </section>
    </>
  );
}
